// Copyright (c) Microsoft Corporation. All rights reserved.

import "../App.css";

import React from "react";

// Sample Privacy statement page.
class SampleAppPrivacy extends React.Component {
  render() {
    return (
      <div>
        <h1>Privacy</h1>
        <br />
        <p>Your privacy is important to us.</p>
        <br />
        <a
          className="App-link"
          href="https://privacy.microsoft.com/en-us/data-privacy-notice"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn about our commitment
        </a>
      </div>
    );
  }
}

export default SampleAppPrivacy;
